import { isPlatformBrowser } from '@angular/common';
import { Component, Input, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Invoice, InvoiceStatus } from 'src/app/interfaces/invoice';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss']
})
export class InvoicesComponent {
  @Input('displayMyInvoicesImage') public displayMyInvoicesImage: boolean = true;
  @Input('maxNrOfDisplayedPaidInvoices') public maxNrOfDisplayedPaidInvoices = null;

  invoices: Invoice[];
  invoiceStatus = InvoiceStatus;
  isBrowser: boolean;

  public nrOfPaidInvoices: number = null;

  constructor(
    private route: ActivatedRoute,
    private _userService: UserService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (this.route.snapshot.data.invoices) {
      this.invoices = this.route.snapshot.data.invoices as Invoice[];
    } else {
      this.getInvoicesList();
    }
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  filterInvoicesByStatus(status: InvoiceStatus): Invoice[] {
    if (this.invoices) {
      const filteredInvoices = this.invoices.filter(invoice => invoice.status === status);
      if (status === InvoiceStatus.Paid) {
        this.nrOfPaidInvoices = filteredInvoices.length;
      }
      return filteredInvoices;
    } else {
      return [];
    }
  }


  public showInvoicesAreBeingProcessedText() {
    if (this.invoices === undefined){
      return
    }
    if (this.route.snapshot.data.user) {
      const user = this.route.snapshot.data.user;
      const invoiceLength = this.invoices.length
      if ((user.productType === 5 || user.productType === 2) && !user.ultimate && invoiceLength === 0) {
        return true;
      }
      return false;
    }
    return false;
  }

  view(invoice: Invoice): void {
    if (!this.isBrowser) return;
    window.open(invoice.paymentUrl, '_blank');
  }

  public getInvoicesList() {
    this._userService.getInvoices().subscribe((res: Invoice[]) => {
      this.invoices = res;
    });
  }

}
